/**
 * meta中 role       为角色权限，决定用户是否有权限访问该路由
 * keepAlive        为缓存选项，如果该路由需要缓存，值设为true
 * requiresAuth     验证登录权限
 * title            页面标题
 */

import Nofound from '.././components/page/Nofound.vue'
import Iframe from '.././components/page/Iframe.vue'

import Index from '.././components/page/m/index/index.vue' // 首页
// 地图
import MapIndex from ".././components/page/m/map/index/index.vue"; // 地图 周边非遗
import MapQgIndex from ".././components/page/m/map/quanguo/index.vue"; // 全国非遗
import ItemIndex from ".././components/page/m/map/item/index.vue"; // 非遗项目列表
import ItemDetail from ".././components/page/m/map/item/detail.vue"; // 非遗项目详情
// import ItemBaocuo from ".././components/page/m/map/item/baocuo.vue"; // 非遗项目报错
// import ItemComment from ".././components/page/m/map/item/comment.vue"; // 非遗项目评论
import mapAnywhere from ".././components/page/m/map/item/map.vue"; // 地图 具体某个点的高德地图
import searchIndex from ".././components/page/m/search/index.vue"; // 搜索


export default [
    // 内容的模板
    {
        path: '/',
        component: Iframe,
        meta: {
            requiresAuth: false
        },
        children: [
            // 地图
            {
                path: "/", // map/index
                name: "map",
                component: MapIndex,
                meta: {
                    requiresAuth: false,
                    title: "北京中医健康服务体系地图",
                    role: 0,
                    keepAlive: true,
                    // icon_back: false,
                },
            },
            // 全国地图
            {
                path: "quanguo/index",
                name: "map-quanguo",
                component: MapQgIndex,
                meta: {
                    requiresAuth: false,
                    title: "北京中医健康服务体系地图",
                    role: 0,
                    keepAlive: true,
                    // icon_back: false,
                },
            },
            // 非遗项目 列表
            {
                path: "item/index",
                name: "map-item",
                component: ItemIndex,
                meta: {
                    requiresAuth: false,
                    title: "项目列表",
                    role: 0,
                    keepAlive: false,
                    // icon_back: false,
                    // share_config: true,
                },
            },
            // 非遗项目 详情
            {
                path: "item/detail",
                name: "map-itemdetail",
                component: ItemDetail,
                meta: {
                    requiresAuth: false,
                    title: "项目详情",
                    role: 0,
                    // keepAlive: false,
                    // icon_back: true,
                },
            },
            // 地图 按地址搜索
            {
                path: "map/anywhere",
                name: "map-anywhere",
                component: mapAnywhere,
                meta: {
                    requiresAuth: false,
                    title: "地图",
                    role: 0,
                    keepAlive: false,
                    // icon_back: false,
                },
			},
			// 搜索页面
			{
				path: "search/index",
				name: "search",
				component: searchIndex,
				meta: {
				  requiresAuth: false,
				  title: "搜索",
				  role: 0,
				  keepAlive: false,
				//   icon_back: false
				},
			  },
            // 其它404
            {
                path: '*',
                name: 'noaccess',
                component: Nofound,
                meta: {
                    requiresAuth: true,
                    pageTitle: '404'
                }
            }
        ]
    }
]